import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { PaymentService } from '../../services/payment.service';
import { Router } from '@angular/router';
import { State } from '../../../store/reducers';
import { zip } from 'rxjs/observable/zip';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-booking-shell',
  templateUrl: './booking-shell.component.html',
  styleUrls: ['./booking-shell.component.css']
})
export class BookingShellComponent implements OnInit, AfterViewInit, OnDestroy {
  paidForConference$: Observable<any>;
  paidForAccommodation$: Observable<any>;
  overallTotalPrice$: Observable<number>;
  overallConferenceFees$: Observable<number>;
  overallTotalPrice: number;
  conferenceTotalPrice: number;
  numberOfBookings: number;

  overallTotalPriceSubscription: Subscription;
  overallConferenceFeesSubscription: Subscription;
  constructor(
    private store: Store<State>,
    private router: Router,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    // ACCOMMODATION STUFF //
    this.overallTotalPrice$ = this.store.select(
      state => state.booking.overallTotalPrice
    );
    this.overallTotalPriceSubscription = this.overallTotalPrice$.subscribe(
      price => (this.overallTotalPrice = price)
    );

    this.paidForAccommodation$ = this.store.select(
      state => state.payment.paidForAccommodation
    );

    // CONFERENCE STUFF //
    // this.overallConferenceFees$ = zip(
    //   this.store.select(state => state.booking.overallNgynFees),
    //   this.store.select(state => state.booking.numberOfBookings)
    // ).pipe(
    //   map(values => {
    //     const totalNgynFees = values[0];
    //     const totalConferencePrice = values[1] * 55;
    //     return totalNgynFees + totalConferencePrice;
    //   })
    // );
    this.overallConferenceFees$ = this.store
      .select(state => state.booking.numberOfBookings)
      .pipe(map(num => num * 55));

    this.overallConferenceFeesSubscription = this.overallConferenceFees$.subscribe(
      price => {
        this.conferenceTotalPrice = price;
      }
    );

    this.paidForConference$ = this.store.select(
      state => state.payment.paidForConference
    );
  }

  ngAfterViewInit() {
    this.handleAccommodationPayment();
    this.handleConferencePayment();
  }

  handleAccommodationPayment() {
    // Render the PayPal button
    paypal.Button.render(
      {
        // Set your environment

        env: 'production', // sandbox | production

        // Specify the style of the button

        style: {
          layout: 'vertical', // horizontal | vertical
          size: 'medium', // medium | large | responsive
          shape: 'rect', // pill | rect
          color: 'gold' // gold | blue | silver | black
        },

        // Specify allowed and disallowed funding sources
        //
        // Options:
        // - paypal.FUNDING.CARD
        // - paypal.FUNDING.CREDIT
        // - paypal.FUNDING.ELV

        funding: {
          allowed: [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT],
          disallowed: []
        },

        // PayPal Client IDs - replace with your own
        // Create a PayPal app: https://developer.paypal.com/developer/applications/create

        client: {
          sandbox:
            'AUHnVPm38AozNmxu2_8cE50lBAsyYKLqQ-V7awOIN_5J817UOJB5MCRfQhLZzuDA4crdHg0r46QmKhLL',
          production:
            'AScKbWzQhvFJhnV81rNJjxs02dWVa0NI5a2iUQO3q-JPBqsXJRhrrPkRnA_DFOWQjtOBLa_A2cu4rqVV'
        },
        payment: (data, actions) => {
          return actions.payment.create({
            payment: {
              transactions: [
                {
                  amount: {
                    total: `${this.overallTotalPrice.toString()}`,
                    currency: 'USD'
                  }
                }
              ]
            }
          });
        },

        onAuthorize: (data, actions) => {
          return actions.payment.execute().then(() => {
            this.paymentService.processAccommodationPayment(
              data,
              `${this.overallTotalPrice.toString()}`
            );
            window.alert('Payment Complete!');
            this.router.navigate(['/bookings']);
          });
        }
      },
      '#accommodation-button-container'
    );
  }

  handleConferencePayment() {
    // Render the PayPal button
    paypal.Button.render(
      {
        // Set your environment

        env: 'production', // sandbox | production

        // Specify the style of the button

        style: {
          layout: 'vertical', // horizontal | vertical
          size: 'medium', // medium | large | responsive
          shape: 'rect', // pill | rect
          color: 'gold' // gold | blue | silver | black
        },

        // Specify allowed and disallowed funding sources
        //
        // Options:
        // - paypal.FUNDING.CARD
        // - paypal.FUNDING.CREDIT
        // - paypal.FUNDING.ELV

        funding: {
          allowed: [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT],
          disallowed: []
        },

        // PayPal Client IDs - replace with your own
        // Create a PayPal app: https://developer.paypal.com/developer/applications/create

        client: {
          sandbox:
            'AQKOHGhoItLReuWyMXiL-1SDPzO6sYiqCDhR7HZJ0aXKIDr0f48130uVmOJae53Jnlv-STyrS_PLbB0e',
          production:
            'Af5a9yoorPBR1ObbLthr5AD_vxbIedIdCi21UwJX570s2ntzv1w3cTgx6nZnPyBCPjA4oqYOjbMAcp2c'
        },
        payment: (data, actions) => {
          return actions.payment.create({
            payment: {
              transactions: [
                {
                  amount: {
                    total: `${this.conferenceTotalPrice}`,
                    currency: 'USD'
                  }
                }
              ]
            }
          });
        },

        onAuthorize: (data, actions) => {
          return actions.payment.execute().then(() => {
            this.paymentService.processAccommodationPayment(
              data,
              `${this.conferenceTotalPrice}`
            );
            window.alert('Payment Complete!');
            this.router.navigate(['/bookings']);
          });
        }
      },
      '#conference-button-container'
    );
  }

  ngOnDestroy() {
    if (this.overallConferenceFeesSubscription) {
      this.overallConferenceFeesSubscription.unsubscribe();
    }
    if (this.overallTotalPriceSubscription) {
      this.overallTotalPriceSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/booking-shell/booking-shell.component.ts